<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <div class="side-frame">
        <span class="side-frame-text">线路基本信息</span>
      </div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="线路名称" prop="lineName">
            <el-input
              clearable
              v-model="formData.lineName"
              :disabled="disabled"
              placeholder="请输入线路名称"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="线路类型" prop="lineType">
            <el-radio label="R" v-model="formData.lineType" :disabled="disabled"
              >收货线路</el-radio
            >
            <el-radio label="D" v-model="formData.lineType" :disabled="disabled"
              >送货线路</el-radio
            >
            <el-radio label="Z" v-model="formData.lineType" :disabled="disabled"
              >不指定</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="承运商" prop="carrierCode">
            <dict-select
              filterable
              :disabled="disabled"
              v-model="formData.carrierCode"
              url="/master/carrier/info/select"
              placeholder="请选择承运商"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="承运商合同" prop="contractCarrierCode">
            <dict-select
              filterable
              :disabled="disabled"
              clearable
              style="width: 100%"
              v-model="formData.contractCarrierCode"
              placeholder="请选择承运商合同"
              url="/contract/carrier/select"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="组织机构">
            <org-cascader
              filterable
              :disabled="disabled"
              :valueString.sync="formData.orgCodeList"
              :props="{multiple: true}"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="有效状态" prop="lineStatus">
            <el-radio
              label="Y"
              v-model="formData.lineStatus"
              :disabled="disabled"
              >已审核</el-radio
            >
            <el-radio
              label="N"
              v-model="formData.lineStatus"
              :disabled="disabled"
              >新增</el-radio
            >
            <el-radio
              label="D"
              v-model="formData.lineStatus"
              :disabled="disabled"
              >删除</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="可用日期类型" prop="useDayType">
            <el-radio-group :disabled="disabled"
              v-model="formData.useDayType"
              @change="useBayTypeChange()"
            >
              <el-radio label="W">按周</el-radio>
              <el-radio label="D">按日</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item prop="useDaySet">
      <el-row v-if="formData.useDayType === 'W'" :gutter="10">
        <el-col :span="24">
          <el-checkbox-group v-model="formData.useDaySet">
            <el-checkbox :disabled="disabled" :label="1">周一</el-checkbox>
            <el-checkbox :disabled="disabled" :label="2">周二</el-checkbox>
            <el-checkbox :disabled="disabled" :label="3">周三</el-checkbox>
            <el-checkbox :disabled="disabled" :label="4">周四</el-checkbox>
            <el-checkbox :disabled="disabled" :label="5">周五</el-checkbox>
            <el-checkbox :disabled="disabled" :label="6">周六</el-checkbox>
            <el-checkbox :disabled="disabled" :label="7">周日</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-row v-if="formData.useDayType === 'D'" :gutter="10">
        <el-col :span="24">
          <el-checkbox-group v-model="formData.useDaySet">
            <el-checkbox :disabled="disabled" v-for="index in days" :label="index" :key="index">{{
              index
            }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      </el-form-item>
      
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="线路说明" prop="lineDesc">
            <el-input
              clearable
              type="textarea"
              rows="3"
              v-model="formData.lineDesc"
              placeholder="请输入线路说明"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      useWeekSet: [],
      rules: {
        lineName: [
          {required: true, message: '请输入线路名称', trigger: 'blur'},
        ],
        lineType: [
          {required: true, message: '请选择线路类型', trigger: 'change'},
        ],
        carrierCode: [
          {required: true, message: '请选择承运商', trigger: 'change'},
        ],
        contractCarrierCode: [
          {required: true, message: '请选择承运商合同', trigger: 'change'},
        ],
        useDayType: [
          {required: true, message: '请选择可用日期类型', trigger: 'change'},
        ],
        useDaySet: [
          {type:'array', required: true, message: '请选择可用日期', trigger: 'change'},
        ],
        lineStatus: [
          {required: true, message: '请选择有效状态', trigger: 'change'},
        ],
      },
    }
  },
  computed: {
    days() {
      return Array.from({length: 31}).map((v, i) => i + 1)
    },
  },
  methods: {
    useBayTypeChange() {
      this.formData.useDaySet = []
    },
    reset() {
      this.formData = {}
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
    },
    async getFormData() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.$message.error('有必填字段未填写，请检查')
        return
      }

      return this.formData
    },
  },
}
</script>
